module.exports = __webpack_public_path__ + "img/GP.7b448512.svg";